import { FormBase } from '@models/portal/users/form-base';
import { MetadataPutEnum } from '@models/enums/metadata-put-enum';
import { ITieBreakCriteriaDto } from '../dtos/tie-break-criteria-dto';
import { CriteriaModalityEnum } from '../enum/criteria-modality-type';

export class ModalityCriteriaForm extends FormBase {
    crdNrId?: number;
    mocNrOrdem?: number;
    mocTxTipo?: CriteriaModalityEnum;

    constructor() {
        super();
    }

    public static createFromDto(dto: ITieBreakCriteriaDto): ModalityCriteriaForm {
        const form = new ModalityCriteriaForm();
        form.crdNrId = dto.crdNrId ?? undefined;
        form.mocNrOrdem = dto.mocNrOrdem ?? undefined;
        form.entNrId = dto.mocNrId ?? undefined;
        form.mocTxTipo = dto.mocTxTipo as CriteriaModalityEnum ?? undefined;
        form.entTxMetadado = MetadataPutEnum.INALTERADO;
        return form;
    }

    public static buildPutForm(newForm: ModalityCriteriaForm, current?: ITieBreakCriteriaDto): ModalityCriteriaForm {
        const form = new ModalityCriteriaForm();
        form.crdNrId = newForm.crdNrId;
        form.mocNrOrdem = newForm.mocNrOrdem;
        form.mocTxTipo = newForm.mocTxTipo;
        form.entNrId = newForm.entNrId ?? current?.mocNrId;

        const modified =
            form.crdNrId !== current?.crdNrId ||
            form.mocNrOrdem !== current?.mocNrOrdem ||
            form.mocTxTipo !== current?.mocTxTipo;

        form.entTxMetadado = modified ? MetadataPutEnum.ALTERADO : MetadataPutEnum.INALTERADO;
        return form;
    }

    public verifyChanges(current?: ITieBreakCriteriaDto): void {
        if (!current || !current.mocNrId) {
            this.entTxMetadado = MetadataPutEnum.CRIADO;
            return;
        }

        const modified =
            this.crdNrId !== current.crdNrId ||
            this.mocNrOrdem !== current.mocNrOrdem ||
            this.mocTxTipo !== current.mocTxTipo;

        this.entTxMetadado = modified ? MetadataPutEnum.ALTERADO : MetadataPutEnum.INALTERADO;
    }

    public static markAsDeleted(mocNrId: number, wasDeleted: boolean): ModalityCriteriaForm {
        const form = new ModalityCriteriaForm();
        form.entNrId = mocNrId;
        form.entTxMetadado = wasDeleted ? MetadataPutEnum.DELETADO : MetadataPutEnum.INALTERADO;
        return form;
    }

    public static of(data: Partial<ModalityCriteriaForm>): ModalityCriteriaForm {
        const form = new ModalityCriteriaForm();
        form.crdNrId = data.crdNrId;
        form.mocNrOrdem = data.mocNrOrdem;
        form.mocTxTipo = data.mocTxTipo;
        form.entNrId = data.entNrId;
        form.entTxMetadado = data.entTxMetadado ?? MetadataPutEnum.CRIADO;
        return form;
    }
}
